import { FOOTER_INFO } from '../../constants/footer.js';
import { Link } from 'react-router-dom';

const LOGO_URL =
	'https://res.cloudinary.com/deagvpc2p/image/upload/f_webp,q_auto/v1770486714/Logotipo_Fondo_bgk6ah.png';

function Footer() {
	const isExternalLink = href => href.startsWith('http');

	return (
		<footer className='w-full border-t border-white/5 bg-[#050505]'>
			<div className='pointer-events-none h-px w-full bg-gradient-to-r from-transparent via-white/10 to-transparent' />

			<div className='mx-auto w-full max-w-[1400px] px-6 py-16 lg:px-10 lg:py-20'>
				<div className='flex flex-col items-start justify-between gap-12 md:flex-row'>
					<div className='space-y-6'>
						<div className='flex items-center gap-3'>
							<img
								src={LOGO_URL}
								alt='Logotipo de CodingFlash'
								loading='lazy'
								decoding='async'
								referrerPolicy='no-referrer'
								className='h-6 w-6 rounded-full object-cover object-center'
							/>
							<span className='font-display text-[1.65rem] font-bold uppercase tracking-[0.12em] text-primary'>
								{FOOTER_INFO.brand}
							</span>
						</div>

						<p className='max-w-xs text-sm font-light text-primary/40'>
							{FOOTER_INFO.description}
						</p>
					</div>

					<div className='grid grid-cols-2 gap-10 md:grid-cols-3 md:gap-16'>
						<div className='flex flex-col gap-4'>
							<span className='text-xs font-bold uppercase tracking-widest text-primary/20'>
								Legal
							</span>
							{FOOTER_INFO.legal.map(item => (
								<Link
									key={item.id}
									to={item.href}
									className='text-sm text-primary/60 transition-colors hover:text-primary'
								>
									{item.label}
								</Link>
							))}
						</div>

						<div className='flex flex-col gap-4'>
							<span className='text-xs font-bold uppercase tracking-widest text-primary/20'>
								Social
							</span>
							{FOOTER_INFO.social.map(item => (
								<a
									key={item.id}
									href={item.href}
									{...(isExternalLink(item.href)
										? { target: '_blank', rel: 'noopener noreferrer' }
										: {})}
									className='text-sm text-primary/60 transition-colors hover:text-primary'
								>
									{item.label}
								</a>
							))}
						</div>

						<div className='col-span-2 flex min-w-0 flex-col gap-4 md:col-span-1'>
							<span className='text-xs font-bold uppercase tracking-widest text-primary/20'>
								Ubicación
							</span>
							<span className='text-sm text-primary/60'>
								{FOOTER_INFO.location}
							</span>
							<a
								href={`mailto:${FOOTER_INFO.email}`}
								className='max-w-full break-words text-xs text-primary/60 transition-colors hover:text-primary [overflow-wrap:anywhere] sm:text-sm'
							>
								{FOOTER_INFO.email}
							</a>
						</div>
					</div>
				</div>

				<div className='mt-16 flex flex-col items-start gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-primary/20 sm:mt-20'>
					<span>{FOOTER_INFO.copyright}</span>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
